import { useTranslation } from 'react-i18next'

import { Badge } from './Badge'

export default function NewBadge(props) {
  const [t] = useTranslation()
  return <Badge {...props}>{t('NewBadge.title')}</Badge>
}
